const qrcodeResponseFormat = {
  base64Image: 0,
  emv: 1,
  base64ImageAndEmv: 2
};

module.exports = qrcodeResponseFormat;
